import React from 'react';

/** Contenu A4 du dossier pilote — partagé écran / impression. */
const PartnerBriefSheet: React.FC = () => (
  <article className="print-sheet bg-white text-ink p-8 sm:p-10">
    <header className="flex items-start justify-between gap-6 border-b border-gray-200 pb-4">
      <div>
        <p className="section-label mb-1">Dossier pilote · 1 page</p>
        <h1 className="font-serif text-2xl sm:text-3xl leading-tight">
          BookShare dans votre bibliothèque
        </h1>
        <p className="text-sm text-ink-muted mt-1">Bruxelles · remise en hall, aux heures d’ouverture</p>
      </div>
      <p className="text-xs text-ink-faint text-right shrink-0 pt-1">
        bookshare.be/partenaires
        <br />
        partenaires@bookshare.be
      </p>
    </header>

    <p className="mt-5 text-[15px] leading-relaxed">
      BookShare n’est pas une bibliothèque privée. Les particuliers s’échangent un livre{' '}
      <strong className="font-medium">chez vous</strong>, cinq minutes, comme n’importe quel usager.
      Vous gagnez des visites. Vous ne gagnez ni stock, ni guichet, ni litige : caution et médiation
      restent chez BookShare.
    </p>

    <div className="mt-6 grid sm:grid-cols-2 gap-4">
      <section>
        <h2 className="text-xs font-semibold tracking-widest uppercase text-forest-700 mb-2">
          Ce que vous gagnez
        </h2>
        <ul className="space-y-1.5 text-sm text-ink-muted leading-snug">
          <li>Du public 25–40 ans, souvent non inscrit, qui franchit la porte.</li>
          <li>Un rôle de lieu sûr : mieux qu’un échange dans la rue ou un café.</li>
          <li>Des titres que vous n’achèterez pas (épuisés, langues, fonds privés).</li>
          <li>Zéro ligne budgétaire livres. Affiche A4, pas un totem.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xs font-semibold tracking-widest uppercase text-forest-700 mb-2">
          Ce que nous ne demandons jamais
        </h2>
        <ul className="space-y-1.5 text-sm text-ink-muted leading-snug">
          <li>Ranger des livres BookShare dans vos rayons.</li>
          <li>Faire scanner, valider ou arbitrer par un agent.</li>
          <li>Une commission, de l’argent échangé sur place, l’exclusivité.</li>
        </ul>
      </section>
    </div>

    <section className="mt-6">
      <h2 className="text-xs font-semibold tracking-widest uppercase text-forest-700 mb-2">
        Protocole
      </h2>
      <p className="text-sm text-ink-muted leading-relaxed">
        Hall uniquement, heures d’ouverture. Pas le bureau. Responsabilité : utilisateurs et
        BookShare. Un rendez-vous de rue n’est pas couvert par notre garantie. Vous pouvez arrêter
        le pilote sans frais, à tout moment.
      </p>
    </section>

    <section className="mt-5 border border-gray-200 rounded-lg overflow-hidden">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-paper text-left text-xs tracking-wide uppercase text-ink-muted">
            <th className="px-3 py-2 font-medium">Pilote</th>
            <th className="px-3 py-2 font-medium">Engagement</th>
          </tr>
        </thead>
        <tbody className="text-ink-muted">
          <tr className="border-t border-gray-200">
            <td className="px-3 py-2">Durée</td>
            <td className="px-3 py-2 text-ink">3 mois, une antenne, réversible</td>
          </tr>
          <tr className="border-t border-gray-200">
            <td className="px-3 py-2">Lieu</td>
            <td className="px-3 py-2 text-ink">Hall · pas de stockage BookShare</td>
          </tr>
          <tr className="border-t border-gray-200">
            <td className="px-3 py-2">Suivi</td>
            <td className="px-3 py-2 text-ink">Chiffres de passage, agrégés, chaque mois</td>
          </tr>
        </tbody>
      </table>
    </section>

    <p className="mt-6 text-sm font-serif text-ink leading-relaxed">
      La bibliothèque n’héberge pas BookShare. Elle reste le bâtiment public où la lecture circule —
      y compris des livres qu’elle n’a pas achetés.
    </p>
  </article>
);

export default PartnerBriefSheet;
